module.exports = __webpack_public_path__ + "static/media/hand-spock.02e3137e.svg";